import type { FC } from 'react'
import styled from 'styled-components'

import Card from './Card'

interface Props {
  label: string
  icon: string
  actionButton?: React.ReactNode
  isExpanded: boolean
  handleExpand?: Function
  expandedContent: React.ReactNode
}

const Container = styled(Card)<{ $isExpanded: boolean }>`
  overflow-y: auto;

  padding-left: 20px;
  padding-right: 20px;
`

const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr min-content;
  align-items: center;

  h4 {
    color: #34bebd;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
  }
`

const InnerHeader = styled.div<{ $canToggleExpand: boolean }>`
  display: grid;
  grid-column-gap: 30px;
  align-items: center;
  grid-template-columns: ${props =>
    props.$canToggleExpand ? 'min-content min-content 1fr' : 'min-content 1fr'};
  cursor: ${props => (props.$canToggleExpand ? 'pointer' : 'default')};

  &:hover {
    background: ${props => (props.$canToggleExpand ? '#F7F7F7;' : '')};
  }
`

const ExpandCollapse = styled.img<{ $isExpanded: boolean }>`
  width: 55px;
  transform: rotate(${props => (props.$isExpanded ? '270deg' : '180deg')});
`

const ExpandableCard: FC<Props> = ({
  icon,
  label,
  actionButton,
  expandedContent,
  isExpanded,
  handleExpand,
}) => (
  <Container $isExpanded={isExpanded}>
    <Header>
      <InnerHeader
        aria-label="Expandable card header"
        $canToggleExpand={handleExpand !== undefined}
        onClick={() => (handleExpand !== undefined ? handleExpand() : undefined)}
      >
        {handleExpand !== undefined && (
          <div>
            <ExpandCollapse
              $isExpanded={isExpanded}
              src="/assets/svg/collapse.svg"
              alt=""
            />
          </div>
        )}
        <div>
          <img
            src={`/assets/svg/${icon}.svg`}
            alt=""
            style={{
              marginRight: 5,
              maxWidth: 45,
            }}
          />{' '}
        </div>
        <div>
          <h4>{label}</h4>
        </div>
      </InnerHeader>
      {actionButton && <div>{actionButton}</div>}
    </Header>
    {isExpanded && expandedContent}
  </Container>
)

export default ExpandableCard
